export default "__VITE_ASSET__y1LhWCrd__"